module.exports = __webpack_public_path__ + "static/media/iraq.6de9e452.gif";